// mixed from internet sources

import type { ColorValue } from "../color-value";
import type { RGBA } from "../rgba-color/rgba-color";
import { rgbaToString } from "./rgba-to-string";

const ONE_THIRD = 1 / 3;

const hueToRgb = (p: number, q: number, t: number) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
const hslaToRgba = (
    hue: number,
    saturation: number,
    light: number,
    alpha = 1,
): RGBA => {
    if (saturation === 0) {
        const gray = Math.round(light * 255);
        return { red: gray, green: gray, blue: gray, alpha };
    }
    const q =
        light < 0.5
            ? light * (saturation + 1)
            : light + saturation - light * saturation;
    const p = 2 * light - q;
    const huePercentage = hue / 360;

    return {
        red: Math.round(hueToRgb(p, q, huePercentage + ONE_THIRD) * 255),
        green: Math.round(hueToRgb(p, q, huePercentage) * 255),
        blue: Math.round(hueToRgb(p, q, huePercentage - ONE_THIRD) * 255),
        alpha,
    };
};
const hslaToRgbaString = (color: {
    hue: ColorValue["hue"];
    saturation: ColorValue["saturation"];
    light: ColorValue["light"];
    alpha?: ColorValue["alpha"];
}) => {
    const { hue, saturation, light, alpha = 1 } = color;
    const rgba = hslaToRgba(hue, saturation, light, alpha);
    return rgbaToString(rgba);
};

export { hslaToRgba, hslaToRgbaString };
